import * as path from "path-browser";
import { PATH_PREFIX, LIB_PREFIX } from "../../TypesAndIdentifiers";
import ContentPaths from "../utils/ContentPaths";

export default class ActivityPaths extends ContentPaths {
    constructor(id: string) {
        const escapedID = id.replace(LIB_PREFIX, "");
        const [, type, content] = escapedID.split(".");
        let root;
        // set root path
        root = path.join(PATH_PREFIX, type, content);
        super(id, root);

        // set lib file path
        this.lib = path.join(
            this.domain,
            LIB_PREFIX,
            type,
            content,
            `${id}.js`
        );
    }
}
